import React from "react";
import {Link} from "react-scroll";
import {Phone, X, MenuIcon} from "lucide-react";

export const Header = () => {

    return (
        <header className='site-header'>
            <nav className='navbar section-content'>
                <a href='#hero' className='nav-logo'>
                    <h2 className='logo-text'>
                        A to Z Auto Repair Center
                    </h2>
                </a>
                <a href='tel:+16235216105' className='header-call-button'>
                    <Phone size={18} strokeWidth={2.4} aria-hidden='true'/>
                    <span>623-521-6105</span>
                </a>

                {/* Header Navbar Options */}
                <ul className='nav-menu'>
                    {/*Button to close menu*/}
                    <button id='menu-close-button' className='fas fa-times' aria-label='Close menu'>
                        <X/>
                    </button>
                    
                    <li className='nav-item'>
                        <Link activeClass='active' to='about' spy={true} smooth={true} offset={-90} duration={500} className='nav-link'>
                            About
                        </Link>
                    </li>

                    <li className='nav-item'>
                        <Link activeClass='active' to='services' spy={true} smooth={true} offset={-90} duration={500} className='nav-link'>
                            Services
                        </Link>
                    </li>

                    <li className='nav-item'>
                        <Link activeClass='active' to='contact' spy={true} smooth={true} offset={-90} duration={500} className='nav-link'>
                            Contact
                        </Link>
                    </li>

                    <li className='nav-item nav-cta-item'>
                        <Link activeClass='active' to='contact' spy={true} smooth={true} offset={-90} duration={500} className='nav-cta nav-link'>
                            Se habla Español!
                        </Link>
                    </li>
                </ul>

                {/* Butto to fully close menu */}
                <button id='menu-open-button' className='fa fa-bars' aria-label='Open menu'>
                    <MenuIcon/>  
                </button>
            </nav>
        </header>
    )
}
